import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { find, isObject } from 'lodash';
import CustomDropDownArray from '../../../../utils/redux-forms-custom-fields/CustomDropDownArray';
import CustomInput from '../../../../utils/redux-forms-custom-fields/CustomInput';

const Rules = ({
  fields,
  meta: { error },
  configRules,
  questForm,
  stepIndex
}) => {
  const ruleOptions = configRules.map(rule => ({
    label: rule.name,
    value: rule.id,
  }));

  const getConditioningFactorAllowed = (index) => {
    if (questForm.values?.steps?.length > 0 &&
        questForm.values.steps[stepIndex]?.rules?.length > 0) {
      const theRule = find(
        configRules, 
        myRule => myRule.id === questForm.values.steps[stepIndex].rules[index].id
      );
      return isObject(theRule) ? theRule.conditioningFactorAllowed : false;
    }
    return false;
  };

  return (
    <section className="RepeaterWrapper Rules">
      <ul>
        {fields.map((rule, index) => {
          const conditioningFactorAllowed = getConditioningFactorAllowed(index);

          return (
            <li key={index}>
              <section className="RepeaterWrapper__header">
                <button 
                  className="RepeaterWrapper__item-remove" 
                  type="button" 
                  onClick={() => fields.remove(index)}
                >
                  <i className="fa fa-trash" />
                </button>
                <h4 className="RepeaterWrapper__title">Rule #{index + 1}</h4>
              </section>

              <section className="RepeaterWrapper__fields">
                <Field
                  name={`${rule}.id`}
                  id={`${rule}.id`}
                  placeholder="Select Type"
                  customLabel="Type"
                  component={CustomDropDownArray}
                  options={ruleOptions}
                />

                {conditioningFactorAllowed && (
                  <Field
                    name={`${rule}.conditioningFactor`}
                    id={`${rule}.conditioningFactor`}
                    type="number"
                    component={CustomInput}
                    placeholder="Conditioning Factor"
                    label="Conditioning Factor"
                    customLabel="Conditioning Factor"
                  />
                )}
              </section>
            </li>
          );
        })}
      </ul>

      {error && <span className="RepeaterWrapper__error">{error}</span>}
      
      <button 
        className="RepeaterWrapper__add-item" 
        type="button" 
        onClick={() => fields.push({})}
      >
        Add Rule
      </button>
    </section>
  );
};

Rules.propTypes = {
  fields: PropTypes.object.isRequired,
  meta: PropTypes.shape({
    error: PropTypes.string
  }).isRequired,
  configRules: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      conditioningFactorAllowed: PropTypes.bool
    })
  ).isRequired,
  questForm: PropTypes.shape({
    values: PropTypes.shape({
      steps: PropTypes.arrayOf(
        PropTypes.shape({
          rules: PropTypes.array
        })
      )
    })
  }).isRequired,
  stepIndex: PropTypes.number.isRequired
};

export default Rules;